var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.0001L4 15.0001L5.414 13.5861L13 21.1711L26.586 7.58606L28 9.00006L13 24.0001Z",
    fill: "url(#paint0_linear_1277_709)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1277_709",
    x1: 4,
    y1: 15.7931,
    x2: 28,
    y2: 15.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C7495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3C0D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTrial);
export default __webpack_public_path__ + "static/media/freeTrial.b6d2df1df34e16a77feb6de6f4a0386e.svg";
export { ForwardRef as ReactComponent };